// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.workbench-editor[data-v-5e31093a]{border:1px solid #dcdfe6;line-height:normal;position:relative;z-index:1}.editor-toolbar[data-v-5e31093a]{border-bottom:1px solid #dcdfe6}.editor-body[data-v-5e31093a]{height:360px;overflow-y:hidden}.editor-hint[data-v-5e31093a]{padding:10px;color:#909399;font-size:12px;border-top:1px solid #ebeef5;line-height:1.5}.workbench-editor[data-v-5e31093a] .w-e-full-screen-container{z-index:4000}\n", ""]);
// Exports
module.exports = exports;
